var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main-content main-crm-content" }, [
      _c("div", { staticClass: "container content-title" }, [
        _c("img", {
          staticClass: "img-box",
          attrs: { src: require("static/images/trait/cx2.png"), alt: "oa" }
        }),
        _c("h3", { staticClass: "services-title1" }, [
          _vm._v("营销中心解决方案")
        ])
      ]),
      _c("div", { staticClass: "container new-list" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3226c00c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /opt/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3226c00c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!/opt/node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/services/marketing/Content.vue
// module id = zxM9
// module chunks = 10